export default __webpack_public_path__ + "static/media/arrow_impact.cf2671ac.mp3";